import { render, staticRenderFns } from "./CustDataViewPermission.vue?vue&type=template&id=a3a3a660&scoped=true"
import script from "./CustDataViewPermission.vue?vue&type=script&lang=js"
export * from "./CustDataViewPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a3a660",
  null
  
)

export default component.exports